import React, { PropTypes } from 'react'
import { TabsModule } from '../Tabs'
import selectn from 'selectn'
import { AnchorLink } from '../../common'
/**
 * [Individual schedule component]
 * @return {[type]} [component]
 */
export class Schedule extends React.Component {
  constructor(props) {
    super(props)
  }
  static propTypes = {
    children: PropTypes.object
  }
  render() {
    const { data={}, team={}, datakey, isMobile } = this.props

    if((typeof data === 'undefined') || (typeof team === 'undefined')) {
      return <span></span>
    }
    const gameStatusProps = {
      broadcast : data.broadcast,
      aggregate : data.score,
      dateFormatted : data.dateFormatted,
      gameTime : data.gameTime,
      status : data.status,
      htGameDetail: data.htGameDetail,
      isHTScoreAvailable: data.isHTScoreAvailable
    }
    const teamA = data.teamA
    const teamB = data.teamB
    //console.info('======>data modified',data)
    //console.info('======>homeTeam',homeTeam)
    let gameStripArr = [
      <TeamInfoTag key={'tia-'+datakey} teamProps={teamA} />,
      <GamestatusTag key={'gs-'+datakey} gameStatusProps={gameStatusProps} />,
      <TeamInfoTag key={'tih-'+datakey} teamProps={teamB} />
    ]
    let AnchorTag = (
      (data.href) ? 
      <AnchorLink trackingName={data.trackingName} key={'ac-'+datakey} to={data.href} classes="competitors" isRouterLink={false}>
        {gameStripArr}
      </AnchorLink>
      : <a name={data.trackingName} className="competitors">{gameStripArr}</a>
    )
    let broadcastTag = (
      data.broadcast ? <a href="#" className="bt-sport-link external">{data.broadcast}</a> : ''
    )
    
    let scheduleTag = [
      <header key={'hd-'+datakey} className={data.gameStripClassname}>
        <div className="game-details header"></div>
        {AnchorTag}
        {broadcastTag}
      </header>,
      <div key={'gidiv-'+datakey} className={data.gameDetailsClassname}>
        <GameLeagueInfoTag key={'gli'+datakey} leagueName={data.leagueName} leagueAbbreviation={data.leagueAbbreviation} isMobile={isMobile} />
      </div>
    ]
    
    return <ScheduleWrapTag key={datakey} datakey={datakey} data={scheduleTag} scrollToLiveClass={data.scrollToLiveClass} isMobile={this.props.isMobile} />
        
  }
}

export const ScheduleWrapTag = ({ data, datakey, isMobile, scrollToLiveClass })=>{
  if(isMobile) {
    return (
      <li key={'li-'+datakey} className={scrollToLiveClass}>
        {data}
      </li>
    )
  }else{
    return (
      <article key={'art-'+datakey}>
        {data}
      </article>
    )
  }
}
export const GameLeagueInfoTag = ({ leagueName, leagueAbbreviation, isMobile })=>{
  if((typeof leagueName === 'undefined') || (typeof leagueAbbreviation === 'undefined')) {
    return <span></span>
  }
  return(
    <div className="wrap">
      {
        (isMobile === true) ? <div className="game-status mobile">{leagueAbbreviation}</div> : <div className="game-status">{leagueName}</div>
      }
    </div>
  )
}
export const GamestatusTag = ({ gameStatusProps })=>{
  const { broadcast, dateFormatted, gameTime, status, htGameDetail, isHTScoreAvailable } = gameStatusProps
  return(
    <div className="game-status">
      {
        (dateFormatted && (status === 'pre')) ? 
          <span className="game-date">{dateFormatted}</span> 
          :
          null
      }
      {
        (gameTime) ? 
          <span className="game-time">{gameTime}</span> 
          :
          null
      }
      <span className="game-play"></span>
      {
        (isHTScoreAvailable === true) ? (
          <span className="aggregate">{htGameDetail}</span>
        ) : <span />
      }
      {
        broadcast ? 
          <span className="network">
            <span href="#">{broadcast}</span>
          </span>
         : 
          null
      }
    </div>    
  )
}

export const TeamInfoTag = ({ teamProps })=>{

  const { logo, name, abbreviation, record, score, className } = teamProps

  let teamContComp = (<div className="team-container">
                <div className="team-info-logo">
                  <picture>
                    <img data-default-src={logo} className="team-logo lazyload" data-src={logo} />
                  </picture>
                </div>
                <div className="team-info">
                  <span className="rank"></span>
                  <span className="team-name">
                    <span className="long-name">{name}</span>
                    <span className="short-name">{name}</span>
                    <span className="abbrev">{abbreviation}</span>
                  </span>
                  {
                    record ? <span className="record">{record}</span>
                    : null
                  }
                </div>
              </div>)
  
  let contentElem = <span />
  {
    (score && (className === 'team-a')) ? 
    contentElem = (
      <div className="team team-a possession">
        <div className="team__content">
          {teamContComp}
          <div className="score-container">
            <span className="score icon-font-after">{score}</span>
          </div>
        </div>
      </div>
    )
    : null
  }
  {
    (score && (className === 'team-b')) ? 
    contentElem = (
      <div className="team team-b possession">
        <div className="team__content">
          <div className="score-container">
            <span className="score icon-font-before">{score}</span>
          </div>
          {teamContComp}
        </div>
      </div>
    )
    : null
  }
  return (
    <div>{contentElem}</div>
  )
}

export const ScheduleDiv = ({ data, team, sport, contentName, isMobile })=>{
  if(typeof data === 'undefined') {
    return <span />
  }
  if((data.length === 0) && (!isMobile)) {
    return ( <p style={{ fontSize:'11px', padding: '10px' }}>No {contentName} available</p> )
  }
  let cont = []
  let dataLen = (data.length > 0) ? data.length : 0
  for(let i=0; i < dataLen; i++) {
    cont.push(<Schedule key={'schd-'+i} datakey={'schd-'+i} data={data[i]} team={team} sport={sport} isMobile={isMobile} />)
  }
  return(
    <div>
      {cont}
    </div>
  )
}

export const TabsHeading = ({ heading })=>{
  if(typeof heading === 'undefined') {
    return <span />
  }
  return (
    <h1 key="hds">
      <div>{heading.text}</div>
      <span>{heading.timeZone}</span>
    </h1>
  )
}

export const FixturesAndResultsMobile = ({ mobileData })=>{
  let { heading, schedule, team, sport, isMobile, notes, fixturesLinkText, fixturesLink, resultsLinkText, resultsLink } = mobileData
  let contentsArr = []
  let dataLen = (schedule.length > 0) ? schedule.length : 0
  if(dataLen <= 0) {
    return <span />
  }
  if(resultsLink) {
    contentsArr.push(
      <li key="reslnkli" className="full-schedule">
        <AnchorLink key="reslnk" to={resultsLink} text={resultsLinkText} classes="icon-font-before icon-calendar-outline-before" />
      </li>
    )
  }
  for(let i=0; i < dataLen; i++) {
    contentsArr.push(<Schedule key={'schd-mob-'+i} datakey={'schd-mob-'+i} data={schedule[i]} team={team} sport={sport} isMobile={isMobile} />)
  }
  if(fixturesLink) {
    contentsArr.push(
      <li key="fixlnkli" className="full-schedule">
        <AnchorLink key="fixlnk" to={fixturesLink} text={fixturesLinkText} classes="icon-font-before icon-calendar-outline-before" />
      </li>
    )
  }
  return(
    <article>
      <section className="club-mobile-schedule scroll" data-behavior="scroll_to_live_game" data-module="module">
          <header>
            <div className="date">{heading.text}</div>
            <div className="notes">{notes}</div>
          </header>
          <ul key="ulmob" className="has-game-strips">
            {contentsArr}
          </ul>
      </section>
    </article>
  )
}

/**
 * Component for schedule(fixtures and results)
 * @return {[type]} [component]
 */
export class FixturesAndResults extends React.Component {
  constructor(props) {
    super(props)
  }
  static propTypes = {
    children: PropTypes.object
  }
  render() {
    if(typeof selectn('schedule', this.props) === 'undefined') {
      return <span></span>
    }

    let { isMobile='', schedule={}, sport='', team='' } = this.props
    let { heading={}, mobile=[], notes='', fixturesLinkText='', resultsLinkText='' } = schedule

    if(isMobile) {
      let mobileData = {
        heading: heading,
        isMobile: isMobile,
        schedule: mobile,
        team: team,
        sport: sport,
        notes: notes,
        fixturesLinkText: fixturesLinkText,
        fixturesLink: selectn('fixtures.link', schedule),
        resultsLinkText: resultsLinkText,
        resultsLink: selectn('results.link', schedule)
      }
      return (
        <FixturesAndResultsMobile key="mob-sch-mod" mobileData={mobileData} />
        )
    }

    const tabAData = selectn('fixtures.items', schedule)
    const tabAContentName = selectn('fixtures.name', schedule)
    const tabAContentText = selectn('fixtures.text', schedule)
    const tabBData = selectn('results.items', schedule)
    const tabBContentName = selectn('results.name', schedule)
    const tabBContentText = selectn('results.text', schedule)

    const tabHeadingChildren = <TabsHeading key="sch-hdr" heading={heading} />
    const tabAContChildren = <ScheduleDiv key="sch-div-1" data={tabAData} contentName={tabAContentName} team={this.props.team} sport={this.props.sport} isMobile={isMobile} />
    const tabBContChildren = <ScheduleDiv key="sch-div-2" data={tabBData} contentName={tabBContentName} team={this.props.team} sport={this.props.sport} isMobile={isMobile} />
    
    const tabsModule = {
      key: 'tm',
      type: 'module',
      moduleClassName: 'club-schedule alt',
      tabSizeClassName: 'lg',
      heading: {
        component: tabHeadingChildren
      },
      tabs: [
        {
          name: tabAContentName,
          text: tabAContentText,
          active: true,
          content: {
            component: tabAContChildren
          }
        },
        {
          name: tabBContentName,
          text: tabBContentText,
          content: {
            component: tabBContChildren
          }
        }
      ]
    }

    return (
        <TabsModule key={tabsModule.key} type={tabsModule.type} data={tabsModule} />
    )
  }
}

export default FixturesAndResults



// WEBPACK FOOTER //
// ../app/components/common/col-a/FixturesAndResults.jsx